module.exports = __webpack_public_path__ + "static/img/culture2.0fe2a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/culture2.png
// module id = HbX8
// module chunks = 1